/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SmsIndexRouteImport } from './routes/sms/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as DevicesIndexRouteImport } from './routes/devices/index'
import { Route as CommissionIndexRouteImport } from './routes/commission/index'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics/index'
import { Route as SimsRegisterIndexRouteImport } from './routes/sims/register/index'
import { Route as SimsMySimsIndexRouteImport } from './routes/sims/my-sims/index'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SmsIndexRoute = SmsIndexRouteImport.update({
  id: '/sms/',
  path: '/sms/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevicesIndexRoute = DevicesIndexRouteImport.update({
  id: '/devices/',
  path: '/devices/',
  getParentRoute: () => rootRouteImport,
} as any)
const CommissionIndexRoute = CommissionIndexRouteImport.update({
  id: '/commission/',
  path: '/commission/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const SimsRegisterIndexRoute = SimsRegisterIndexRouteImport.update({
  id: '/sims/register/',
  path: '/sims/register/',
  getParentRoute: () => rootRouteImport,
} as any)
const SimsMySimsIndexRoute = SimsMySimsIndexRouteImport.update({
  id: '/sims/my-sims/',
  path: '/sims/my-sims/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/commission': typeof CommissionIndexRoute
  '/devices': typeof DevicesIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/sms': typeof SmsIndexRoute
  '/sims/my-sims': typeof SimsMySimsIndexRoute
  '/sims/register': typeof SimsRegisterIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/commission': typeof CommissionIndexRoute
  '/devices': typeof DevicesIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/sms': typeof SmsIndexRoute
  '/sims/my-sims': typeof SimsMySimsIndexRoute
  '/sims/register': typeof SimsRegisterIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/commission/': typeof CommissionIndexRoute
  '/devices/': typeof DevicesIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/sms/': typeof SmsIndexRoute
  '/sims/my-sims/': typeof SimsMySimsIndexRoute
  '/sims/register/': typeof SimsRegisterIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/analytics'
    | '/commission'
    | '/devices'
    | '/settings'
    | '/sms'
    | '/sims/my-sims'
    | '/sims/register'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/analytics'
    | '/commission'
    | '/devices'
    | '/settings'
    | '/sms'
    | '/sims/my-sims'
    | '/sims/register'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/analytics/'
    | '/commission/'
    | '/devices/'
    | '/settings/'
    | '/sms/'
    | '/sims/my-sims/'
    | '/sims/register/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
  CommissionIndexRoute: typeof CommissionIndexRoute
  DevicesIndexRoute: typeof DevicesIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  SmsIndexRoute: typeof SmsIndexRoute
  SimsMySimsIndexRoute: typeof SimsMySimsIndexRoute
  SimsRegisterIndexRoute: typeof SimsRegisterIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sms/': {
      id: '/sms/'
      path: '/sms'
      fullPath: '/sms'
      preLoaderRoute: typeof SmsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devices/': {
      id: '/devices/'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof DevicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/commission/': {
      id: '/commission/'
      path: '/commission'
      fullPath: '/commission'
      preLoaderRoute: typeof CommissionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sims/register/': {
      id: '/sims/register/'
      path: '/sims/register'
      fullPath: '/sims/register'
      preLoaderRoute: typeof SimsRegisterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sims/my-sims/': {
      id: '/sims/my-sims/'
      path: '/sims/my-sims'
      fullPath: '/sims/my-sims'
      preLoaderRoute: typeof SimsMySimsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  CommissionIndexRoute: CommissionIndexRoute,
  DevicesIndexRoute: DevicesIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SmsIndexRoute: SmsIndexRoute,
  SimsMySimsIndexRoute: SimsMySimsIndexRoute,
  SimsRegisterIndexRoute: SimsRegisterIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
